import { POSITIONS } from '../config/positions';

export const getPositionNameByKey = key =>
    POSITIONS.find( p => p.keys.includes( key ) )?.name;